import { Box, Button, Card, MenuItem, TextField } from "@mui/material";
import Grid from "@mui/material/Grid2";
import React from "react";
import { Control, Controller, UseFormWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ERole } from "../../../shared/enums/user/ERole";
import { IUserAction } from "../../../shared/interfaces/user/IUser";

interface IProps {
  control: Control<IUserAction>;
  watch: UseFormWatch<IUserAction>;
  isUpdate?: boolean;
}
const UserForm = ({ control, watch, isUpdate = false }: IProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <Card>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, lg: 4 }}>
          <Controller
            name="email"
            control={control}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <TextField
                error={!!error?.message}
                helperText={error?.message ? t(error.message) : ""}
                value={value ?? ""}
                onChange={onChange}
                label={t("general.email")}
                sx={{ width: "100%" }}
              />
            )}
          />
        </Grid>

        {!isUpdate && (
          <Grid size={{ xs: 12, lg: 4 }}>
            <Controller
              name="password"
              control={control}
              render={({
                field: { onChange, value },
                fieldState: { error },
              }) => (
                <TextField
                  type="password"
                  error={!!error?.message}
                  helperText={
                    error?.message
                      ? t(error.message, { minLength: 6, maxLength: 32 })
                      : ""
                  }
                  value={value ?? ""}
                  onChange={onChange}
                  label={t("general.password")}
                  sx={{ width: "100%" }}
                />
              )}
            />
          </Grid>
        )}

        <Grid size={{ xs: 12, lg: 4 }}>
          <Controller
            name="role"
            control={control}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <TextField
                select
                error={!!error?.message}
                helperText={error?.message ? t(error.message) : ""}
                value={value ?? ""}
                onChange={onChange}
                label={t("general.role")}
                sx={{ width: "100%" }}
              >
                {Object.values(ERole).map((role) => (
                  <MenuItem key={role} value={role}>
                    {t(`roles.${role}`)}
                  </MenuItem>
                ))}
              </TextField>
            )}
          />
        </Grid>

        <Grid size={{ xs: 12, lg: 4 }}>
          <Controller
            name="phoneNumber"
            control={control}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <TextField
                error={!!error?.message}
                helperText={error?.message ? t(error.message) : ""}
                value={value ?? ""}
                onChange={onChange}
                label={t("general.phoneNumber")}
                sx={{ width: "100%" }}
              />
            )}
          />
        </Grid>

        <Grid size={{ xs: 12, lg: 4 }}>
          <Controller
            name="firstName"
            control={control}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <TextField
                error={!!error?.message}
                helperText={error?.message ? t(error.message) : ""}
                value={value ?? ""}
                onChange={onChange}
                label={t("general.firstName")}
                sx={{ width: "100%" }}
              />
            )}
          />
        </Grid>

        <Grid size={{ xs: 12, lg: 4 }}>
          <Controller
            name="lastName"
            control={control}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <TextField
                error={!!error?.message}
                helperText={error?.message ? t(error.message) : ""}
                value={value ?? ""}
                onChange={onChange}
                label={t("general.lastName")}
                sx={{ width: "100%" }}
              />
            )}
          />
        </Grid>
      </Grid>
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button
          variant={"contained"}
          color={"secondary"}
          sx={{ marginTop: "20px" }}
          type={"button"}
          onClick={() => navigate(-1)}
        >
          {t("button.cancel")}
        </Button>
        <Button
          variant={"contained"}
          sx={{ margin: "20px 0 0 10px" }}
          type={"submit"}
        >
          {t(isUpdate ? "button.update" : "button.create")}
        </Button>
      </Box>
    </Card>
  );
};

export default UserForm;
